/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseCrudService, PageResponse, API_CONFIG } from '@nebula-shared/data-access';

export interface ConceptosFacturacionModal {
  id: string;
  codigo: string;
  nombre: string;
  tipoConcepto: string;
  valorUnitario: number;
  estado: string;
  [key: string]: any;
}

interface SearchFilter {
  key: string;
  value: string;
  operation: 'LIKE' | 'EQUALS' | 'CONTAINS' | 'STARTS_WITH' | 'ENDS_WITH';
}

interface PageRequest {
  page: string;
  size: string;
  searchsBy: SearchFilter[];
  ordersBy: any[];
}

@Injectable({ providedIn: 'root' })
export class ConceptosFacturacionService extends BaseCrudService<ConceptosFacturacionModal> {
  constructor() {
    super();
    // Usar la configuración existente de accounting o crear una nueva
    const config = API_CONFIG.invoicing;
    // Asumiendo que el endpoint para conceptos de facturación está en accounting
    this.setBaseUrl(`${config.baseUrl}`);
  }

  /**
   * Método que consume el endpoint page-response
   */
  getConceptosFacturacionPaginados(
    page = 0,
    size = 10,
    searchTerm = '',
    soloActivos = true,
  ): Observable<PageResponse<ConceptosFacturacionModal>> {
    const searchsBy: SearchFilter[] = [];

    // Agregar filtro de búsqueda si existe
    if (searchTerm && searchTerm.trim() !== '') {
      searchsBy.push({
        key: 'nombre',
        value: searchTerm,
        operation: 'LIKE',
      });
    }

    const body: PageRequest = {
      page: page.toString(),
      size: size.toString(),
      searchsBy: searchsBy,
      ordersBy: [],
    };

    return this.http
      .post<
        PageResponse<ConceptosFacturacionModal>
      >(`${this.baseUrl}/conceptos-facturacion/page-response`, body)
      .pipe(
        map((response: any) => {
          const content = response?.response?.content || response?.content || response;

          return {
            content: content?.content || [],
            totalElements: content?.totalElements || 0,
            totalPages: content?.totalPages || 0,
            size: content?.size || size,
            number: content?.number || page,
            first: content?.first || page === 0,
            last: content?.last || false,
            empty: content?.empty || content?.content?.length === 0,
            numberOfElements: content?.numberOfElements || 0,
          } as PageResponse<ConceptosFacturacionModal>;
        }),
      );
  }

  /**
   * Método para obtener todos los conceptos de facturación
   */
  getAllConceptosFacturacion(soloActivos = true): Observable<ConceptosFacturacionModal[]> {
    return this.getConceptosFacturacionPaginados(0, 1000, '', soloActivos).pipe(
      map((response) => response.content || []),
    );
  }

  /**
   * Método para obtener un concepto por ID
   */
  getConceptoFacturacionById(id: string): Observable<ConceptosFacturacionModal> {
    return this.http.get<any>(`${this.baseUrl}/${id}`).pipe(
      map((response: any) => {
        // Adaptar la respuesta si es necesario
        return response?.response || response;
      }),
    );
  }
}
